import React, { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';

export default class EmailInput extends Component {
  render() {
    const { input, meta } = this.props;

    const validationState = meta.touched && meta.error ? 'error' : null;
    const tooltip = validationState ? meta.error : null;

    return (
      <FormGroup validationState={validationState} className="form-group-basic">
        <div className="left-inner-addon">
          <FormControl type="email" placeholder="Email" { ...input } title={tooltip} />
          <i className="input-icon i-apli-email"></i>
        </div>
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/navbar/login-form/email-input.js